import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { BlockedAccountAlert, EmailVerificationAlert } from './login';
import Banner from '../dashboard/mfaBanner';
import queryString from 'query-string';
import { landingBg, logo } from '../../assets/img';
import LandingMarketingAside from './LandingMarketingAside';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, FormField, Input, Typography } from 'components/alf-design';
import { useAuth0 } from 'utils';

const Landing = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = queryString.parse(location.search);
  const [ready, setReady] = useState(null);
  const [showEmailLogin, setShowEmailLogin] = useState(false);
  const [email, setEmail] = useState('');
  const { loginWithRedirect, loading } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({ login_hint: email });
  };

  const handleCreateAccount = () => {
    navigate('/create-account');
  };

  useLayoutEffect(() => {
    if (params.error === 'sign_up_requested') {
      navigate('/create-account');
    }
    setReady(true);
  }, []);

  return (
    !loading &&
    ready && (
      <>
        <Banner />
        <div className="hidden sm:flex w-full px-[108px] pt-[14px] pb-[9px]">
          <img src={logo} alt="Logo" className="w-[116px]" />
        </div>
        <div>
          {params.error === 'unverified_email' && (
            <EmailVerificationAlert params={params} />
          )}
          {params.error === 'unauthorized' &&
            params.error_description === 'user is blocked' && (
              <BlockedAccountAlert />
            )}
        </div>
        <div className="flex flex-1 sm:hidden w-full px-[24px] justify-center">
          <div className="flex flex-col w-full items-center justify-center">
            <div className="w-min">
              <div className="flex justify-center">
                <img src={logo} alt="mySlide" className="h-[40px] w-auto" />
              </div>
              <div className="inline-grid gap-[24px] justify-items-center mt-[40px]">
                <div className="w-[250px]">
                  {showEmailLogin ? (
                    <div>
                      <FormField label="Email address">
                        <Input
                          id="landing-email-input"
                          name="email"
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </FormField>
                      <Button
                        id="continue-button"
                        type="primary"
                        disabled={loading}
                        onClick={handleLogin}
                        className="!text-[18px] h-[40px]"
                        fullWidth
                      >
                        Continue
                      </Button>
                    </div>
                  ) : (
                    <>
                      <Button
                        id="landing-button-login"
                        type="primary"
                        disabled={loading}
                        onClick={() => setShowEmailLogin(true)}
                        className="!text-[18px] h-[40px]"
                        fullWidth
                      >
                        Log In
                      </Button>
                      <div className="flex w-[250px] mt-[24px]">
                        <Button
                          id="landing-button-signup"
                          type="secondary"
                          disabled={loading}
                          onClick={handleCreateAccount}
                          className="!text-[18px] h-[40px]"
                          fullWidth
                        >
                          Create Account
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="hidden sm:flex flex-1 w-full bg-no-repeat bg-cover mr-[24px] ml-[108px] pr-[0px] min-h-[calc(100vh-150px)]"
          style={{ backgroundImage: `url(${landingBg})` }}
        >
          <div className="flex flex-col w-2/5 bg-legacy-white justify-normal content-normal items-center pt-[70px] lg:pl-[20px]">
            <div className="w-min">
              <div className="flex">
                <Typography type="welcome">Welcome Back!</Typography>
              </div>
              <div className="inline-grid gap-[24px] justify-items-center mt-[40px]">
                <div className="w-[150px] lg:w-[250px] xl:w-[310px]">
                  {showEmailLogin ? (
                    <div>
                      <FormField label="Email address">
                        <Input
                          id="landing-email-input"
                          name="email"
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </FormField>
                      <Button
                        id="continue-button"
                        type="primary"
                        disabled={loading}
                        onClick={handleLogin}
                        className="!text-[18px] h-[40px]"
                        fullWidth
                      >
                        Continue
                      </Button>
                    </div>
                  ) : (
                    <Button
                      id="landing-button-login"
                      type="primary"
                      disabled={loading}
                      onClick={() => setShowEmailLogin(true)}
                      className="!text-[18px] h-[40px]"
                      fullWidth
                    >
                      Log In
                    </Button>
                  )}
                </div>
                <div className="flex w-full items-center">
                  <hr className="flex-1" />
                  <Typography className="!text-[16px] p-[8px]">Or</Typography>
                  <hr className="flex-1" />
                </div>
                <div className="flex">
                  <Typography
                    id="landing-button-signup"
                    type="link"
                    onClick={handleCreateAccount}
                    style={{ fontSize: 18 }}
                  >
                    Create Account
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <div className="w-3/5">
            <LandingMarketingAside />
          </div>
        </div>
      </>
    )
  );
};

Landing.propTypes = {
  loading: PropTypes.bool,
};

export default Landing;
